// Browse category "Free-to-air television broadcasting" (id: 555bc5e225a9732ca20a1151)
export const bicsTv = [
  {
    "code": "J562110",
    "desc": "Free-to-air television service",
    "keywords": ["tv"],
    "definition": "If you are self-employed or a small business select the code that relates specifically to the goods and/or services you provide to your customers.",
    "definitionPlainText": "If you are self-employed or a small business select the code that relates specifically to the goods and/or services you provide to your customers.",
    "important": "Generally does not apply to self-employed or small businesses",
    "lastUpdateDate": "2016-02-16T23:11:51.462Z",
    "id": "555c7ba77aaceec91e3f2b20",
    "cuId": "555b1da725a9732ca20a1467",
    "anzsicId": "555b206c25a9732ca20a1140",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1151",
    "cu": {
      "code": "91220",
      "desc": "Free-to-air television broadcasting",
      "id": "555b1da725a9732ca20a1467"
    },
    "anzsic": {
      "code": "J562100",
      "desc": "Free-to-Air Television Broadcasting",
      "id": "555b206c25a9732ca20a1140"
    },
    "bicrefs": [{
      "desc": "You can also use #$0 or #$1 or something else.",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2b21",
        "type": "bic",
        "desc": "J562120 Television station operation (free-to-air)"
      }, 
      {
        "id": "555c7ba77aaceec91e3f2b23",
        "type": "bic",
        "desc": "J562210 Pay TV operation"
      }],
      "id": "5577957b2c8535844998d87f",
      "bicId": "555c7ba77aaceec91e3f2b20",
      "allRefsFoundDesc": true
    }, {
      "desc": "Broadcasting pay TV use #$0",
      "order": 1,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2b23",
        "type": "bic",
        "desc": "J562210 Pay TV operation"
      }],
      "id": "5577957b2c8535844998d880",
      "bicId": "555c7ba77aaceec91e3f2b20",
      "allRefsFoundDesc": true
    }, {
      "desc": "Broadcasting subscription television use #$0",
      "order": 2,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2b24",
        "type": "bic",
        "desc": "J562220 Subscription television broadcasting service"
      }],
      "id": "5577957b2c8535844998d881",
      "bicId": "555c7ba77aaceec91e3f2b20",
      "allRefsFoundDesc": true
    }]
  }, {
    "code": "J562120",
    "desc": "Television station operation (free-to-air)",
    "keywords": ["tv"],
    "definition": "If you are self-employed or a small business select the code that relates specifically to the goods and/or services you provide to your customers.",
    "definitionPlainText": "If you are self-employed or a small business select the code that relates specifically to the goods and/or services you provide to your customers.",
    "important": "Generally does not apply to self-employed or small businesses",
    "lastUpdateDate": "2016-02-16T23:11:56.317Z",
    "id": "555c7ba77aaceec91e3f2b21",
    "cuId": "555b1da725a9732ca20a1467",
    "anzsicId": "555b206c25a9732ca20a1140",
    "lastUpdateUserId": "556d11b3f0529345d1e61d83",
    "classId": "555bc5e225a9732ca20a1151",
    "cu": {
      "code": "91220",
      "desc": "Free-to-air television broadcasting",
      "id": "555b1da725a9732ca20a1467"
    },
    "anzsic": {
      "code": "J562100",
      "desc": "Free-to-Air Television Broadcasting",
      "id": "555b206c25a9732ca20a1140"
    },
    "bicrefs": [{
      "desc": "You can also use #$0",
      "order": 0,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2b20",
        "type": "bic",
        "desc": "J562110 Free-to-air television service"
      }],
      "id": "557795a82c8535844998d882",
      "bicId": "555c7ba77aaceec91e3f2b21",
      "allRefsFoundDesc": true
    }, {
      "desc": "Broadcasting pay TV use #$0",
      "order": 1,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2b23",
        "type": "bic",
        "desc": "J562210 Pay TV operation"
      }],
      "id": "557795a82c8535844998d883",
      "bicId": "555c7ba77aaceec91e3f2b21",
      "allRefsFoundDesc": true
    }, {
      "desc": "Broadcasting subscription television use #$0",
      "order": 2,
      "integrated": false,
      "refs": [{
        "id": "555c7ba77aaceec91e3f2b24",
        "type": "bic",
        "desc": "J562220 Subscription television broadcasting service"
      }],
      "id": "557795a82c8535844998d884",
      "bicId": "555c7ba77aaceec91e3f2b21",
      "allRefsFoundDesc": true
    }]
  }
];